import {Injectable} from '@angular/core';
import {Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { Router } from '@angular/router';
import { ApiService } from "../network/api.service";

import { StorageService } from "../../core/storage/storage.service";
import { TranslatorService } from "../../core/translator/translator.service";

@Injectable()
export class HttpService extends Http {

  private rerequest;

  constructor (backend: XHRBackend,
                  options: RequestOptions,
                  private router: Router,
                  private http: Http,
                  private apiService: ApiService,
                  private translatorService: TranslatorService,
                  private storageService: StorageService) {
    super(backend, options);
  }

  private getRefreshTokenUrl = (): string => this.apiService.getBaseUrl() + '/token';

  request(url: string | Request, request?: RequestOptionsArgs): Observable<Response> {

    if (typeof url === "string") {
        request.headers.append('Accept-Language', this.translatorService.getCurrentLanguage());
    } else {
        url.headers.append('Accept-Language', this.translatorService.getCurrentLanguage());
    }

    return this.http.request(url, request)
      .catch(initialError => {
        if (initialError && initialError.status === 401) {
          // token might be expired, try to refresh token
          return this.refreshToken()
            // flatten response so it's
            .mergeMap( authenticationResult => {
              var response = authenticationResult.json()
              if (response.token) {
                this.storageService.setItem('token', response.token);

                var headers = {
                    'Content-Type': 'application/json',
                    'Authorization': response.token,
                    'Accept-Language': this.translatorService.getCurrentLanguage()
                };

                if (typeof url === "string") {
                    request.headers = new Headers(headers);
                } else {
                    url.headers = new Headers(headers);
                }
                return this.http.request(url, request);
              } else {
                this.storageService.clear();
                this.router.navigate(['login']);
                return Observable.throw(initialError);
              }
            })
            .catch(refreshError => {
              this.storageService.clear();
              this.router.navigate(['login']);
              return Observable.throw(refreshError);
            });
        }
        else if (initialError.status === 0 || initialError.status === 500) {
          this.storageService.clear();
          this.router.navigate(['login']);
          return Observable.throw(initialError);
        } else {
          return Observable.throw(initialError);
        }
      });
  }

  refreshToken () {
    let headers = new Headers ({'Content-Type': 'application/json'});
    let options = new RequestOptions({ headers: headers });
    return this.http.post(this.getRefreshTokenUrl(), {refresh_token: this.storageService.getItem('refreshToken')}, options);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/network/http.service.ts